import { render, staticRenderFns } from "./SerpResultsSortButton.vue?vue&type=template&id=6ad1159c&scoped=true"
import script from "./SerpResultsSortButton.vue?vue&type=script&lang=js"
export * from "./SerpResultsSortButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad1159c",
  null
  
)

export default component.exports